import styles from "../styles/ChatbotData.module.css";

import React, { useContext, useState } from "react";
import cx from "classnames";
import { LanguageContext } from "./App";
import { IoAddSharp } from "react-icons/io5";
import ReactLoading from "react-loading";
import ReactSlider from "react-slider";
import { updateData, updateUpdated } from "./UploadChatBot";
import { TfiSave } from "react-icons/tfi";

export default function KnowledgeBase({ chatbot }) {
  const [notEdited, setNotEdited] = useState(true);
  const [dataArray, setDataArray] = useState(chatbot.data_array);
  const [loading, setLoading] = useState(false);

  const [language, setLanguage] = useContext(LanguageContext);

  const handleAddButtonClick = () => {
    setDataArray([...dataArray, ""]);
  };

  const handleInputChange = (event, index) => {
    const newList = [...dataArray];
    newList[index] = event.target.value;

    setDataArray(newList);
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100wv",
        display: "flex",

        padding: 10,
        overflow: "hidden",
      }}
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
          }}
        >
          <ReactLoading type="spin" color="#000" height={75} width={75} />
        </div>
      ) : null}
      <div className={styles.chatbotDataContainer}>
        <div
          style={{
            fontSize: 16,
            fontFamily: "Jost",
            fontWeight: 600,
            color: "#fff",
          }}
        >
          <h4
            style={{
              fontSize: 19,
              fontFamily: "Jost",
              fontWeight: 600,
              marginBottom: 10,
              color: "#000",
              textAlign: "center",
            }}
          >
            {language === "en"
              ? `The knowledge base of artificial intelligence. If you want to use the chat without AI, you can leave it empty`
              : `База знаний искусственного интеллекта. Если хотите использовать чат без ИИ, можете оставить пустым`}
          </h4>
          <ul>
            {dataArray.map((item, index) => {
              let sliderValue = 800;
              return (
                <li
                  key={index}
                  style={{
                    listStyle: "none",
                    marginBottom: 5,
                    // backgroundColor: "#181413",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: 12,
                    padding: 10,
                  }}
                >
                  <textarea
                    // maxLength={4000}
                    // type="text"
                    value={item}
                    placeholder={
                      language === "en"
                        ? "Enter a text chunk or a link to a page of a website..."
                        : "Введите текст или ссылку на страницу сайта..."
                    }
                    onChange={(e) => {
                      // e.target.style.height = "inherit";
                      // e.target.style.height = `${e.target.scrollHeight}px`;
                      handleInputChange(e, index);
                      setNotEdited(false);
                    }}
                    className={styles.input}
                  />

                  <div style={{ paddingBottom: 10 }}>
                    {item.length > 4000 ? (
                      <div style={{ marginBottom: 100 }}>
                        <h3 style={{ marginLeft: 10 }}>
                          {language === "en"
                            ? `This chunk is too big, divide it into a few chunks of text each
                        approximately X characters with AI`
                            : `Этот блок слишкой большой, разделите этот блок на несколько блоков определенного размера с помощью AI`}
                        </h3>
                        <ReactSlider
                          className="mt-14"
                          marks
                          min={400}
                          max={2000}
                          step={5}
                          defaultValue={800}
                          onChange={(value) => (sliderValue = value)}
                          renderThumb={(props, state) => (
                            <div
                              {...props}
                              style={{ ...props.style, zIndex: 20 }}
                              className="relative flex flex-col items-center w-8 h-8 -mt-2 outline-none"
                            >
                              <div className="absolute top-0 inline-block px-2 py-1 mb-2 -mt-8 text-xs text-white bg-gray-900 rounded-sm whitespace-nowrap">
                                {state.valueNow}{" "}
                                {language === "en"
                                  ? "characters each"
                                  : "символов каждый"}
                              </div>
                              <div className="w-8 h-8 bg-white border-4 border-green-700 rounded-full shadow-lg cursor-pointer" />
                            </div>
                          )}
                          renderTrack={(props, state) => (
                            <div
                              {...props}
                              className={cx("h-4 rounded-full cursor-pointer", {
                                "bg-gray-100": state.index === 1,
                                "bg-green-700 z-10": state.index === 0,
                              })}
                            />
                          )}
                        />
                      </div>
                    ) : null}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        {item.substring(0, 8) === "https://" ||
                        item.substring(0, 7) === "http://" ? (
                          <button
                            className={styles["submit-btn"]}
                            style={{
                              marginBottom: 0,
                              marginLeft: 10,
                              marginTop: 0,
                            }}
                            onClick={async () => {
                              webScrape(
                                item,
                                setDataArray,
                                dataArray,
                                setLoading
                              );
                            }}
                          >
                            {language === "en"
                              ? "Extract text"
                              : "Достать текст из ссылок"}
                          </button>
                        ) : null}
                        {item.length > 4000 ? (
                          <>
                            <button
                              className={styles["submit-btn"]}
                              style={{
                                marginBottom: 0,
                                marginLeft: 10,
                                marginTop: 0,
                              }}
                              onClick={async () => {
                                divideLangChain(
                                  item,
                                  dataArray,
                                  setDataArray,
                                  setLoading,
                                  sliderValue
                                );
                              }}
                            >
                              {language === "en" ? "Split" : "Разделить"}
                            </button>
                            {/* <button
                                className={styles["submit-btn"]}
                                style={{
                                  marginBottom: 0,
                                  marginLeft: 10,
                                  marginTop: 0,
                                }}
                                onClick={async () => {
                                  divideChatGPT(
                                    item,
                                    dataArray,
                                    setDataArray,
                                    setLoading,
                                    sliderValue
                                  );
                                }}
                              >
                                {language === "en"
                                  ? "Split with AI"
                                  : "Разделить с AI"}
                              </button> */}
                          </>
                        ) : null}
                      </div>
                      <button
                        className={styles["delete"]}
                        style={{
                          marginBottom: 0,
                          marginRight: 10,
                          marginTop: 0,
                        }}
                        onClick={async () => {
                          let newData = [...dataArray];
                          if (index !== -1) {
                            newData.splice(index, 1);
                          }
                          setDataArray(newData);
                        }}
                      >
                        {language === "en" ? "Delete" : "Удалить"}
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>

          <button
            className={styles.backBtn}
            onClick={handleAddButtonClick}
            style={{ marginBottom: 0 }}
          >
            <IoAddSharp size={20} color="#000" height={5} width={5} />
          </button>
        </div>
      </div>
      <div
        style={{
          width: "36%",
          marginLeft: 20,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h4
          style={{
            fontSize: 16,
            fontFamily: "Jost",
            fontWeight: 600,

            marginBottom: 10,
            color: "#000",
          }}
        >
          {language === "en" ? `Your data: ` : `Ваши данные: `}
        </h4>
        <div></div>
        <h5
          style={{
            fontSize: 16,
            fontFamily: "Jost",
            fontWeight: 600,

            marginBottom: 10,
            color: "#000",
          }}
        >
          {language === "en"
            ? `Divide your data into blocks, each under its own subtopic. Each block should be less than 2000 characters. It's best to format it as: "Question: Answer". Or paste links to pages of your website and press 'Get text from links'`
            : `Разделите ваши данные на блоки, каждый под свою подтему. Каждый блок менее 2000 символов. Чем меньше блок, тем более точными ответы получатся. Лучше всего сделать в виде: "Вопрос: Ответ", но не обязательно, можно просто вставить блоки текста, разделенные по тематикам. Или вставьте сслыки на страницы ващего сайта и нажмите 'Достать текст из ссылок'`}
        </h5>

        <h5
          style={{
            fontSize: 16,
            fontFamily: "Jost",
            fontWeight: 600,

            marginBottom: 10,
            color: "#000",
          }}
        >
          {language === "en"
            ? `If you have just created a chatbot, our team will need about one day to train a neural network on your data. We will send you an email when ready (you can reply from Telegram yourself right now)!`
            : `Если вы только что создали чат-бота, нашей команде понадобится примерно один день для обучения нейросети на ваших данных. Мы отправим вам email по готовности (отвечать самим из Telegram вы можете уже сейчас)!`}
        </h5>

        <h5
          style={{
            fontSize: 16,
            fontFamily: "Jost",
            fontWeight: 600,

            marginBottom: 10,
            color: "#000",
          }}
        >
          {language === "en"
            ? `If you update an existing chatbot, it will learn by itself!`
            : `Если обновляете уже существующий чат-бот, обучится он сам!`}
        </h5>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <button
            className={styles["submit-btn"]}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
            onClick={async () => {
              for (let i = 0; i < dataArray.length; i++) {
                if (
                  dataArray[i].substring(0, 8) === "https://" ||
                  dataArray[i].substring(0, 7) === "http://"
                ) {
                  if (language === "en") {
                    alert("Don't forget to get text from links!");
                  } else {
                    alert("Не забудьте достать текст из ссылок!");
                  }
                  return;
                } else if (dataArray[i].length > 4000) {
                  if (language === "en") {
                    alert(
                      "One of the chunks is greater than 2000 characters! Please, divide it!"
                    );
                  } else {
                    alert(
                      "Один из блоков текста больше 2000 символом! Пожалуйста, разделите его!"
                    );
                  }
                  return;
                }
              }

              setLoading(true);

              await updateData(chatbot.name, dataArray);
              await fetch(
                "https://ai-chat-bot-docker.onrender.com/writedatatosupabase",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    tableName: chatbot.name,
                  }),
                }
              ).then((response) => {
                response.json().then(async (jsonResponse) => {
                  if (!jsonResponse.success) {
                    await updateUpdated(chatbot.name);
                    if (language === "en") {
                      alert(
                        "Knowledge base has been updated! We couldn't train the chatbot automatically, we'll have to train it manually! We will email you when it is ready (1 day max)"
                      );
                    } else {
                      alert(
                        "База знаний обновлена! Мы не смогли обучить чат-бота автоматически, нам придется самим его обучить! Мы напишем вам, когда будет готово (макс 1 день)"
                      );
                    }
                  }
                });
              });
              setLoading(false);
            }}
          >
            <TfiSave style={{ marginRight: 5 }} size={18} />
            {language === "en" ? "Save" : "Сохранить"}
          </button>
        </div>
      </div>
    </div>
  );
}

async function webScrape(item, setDataArray, dataArray, setLoading) {
  setLoading(true);
  const data = await fetch(
    "https://ai-chat-bot-docker.onrender.com/webscrape",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        url: item,
      }),
    }
  );
  const json = await data.json();
  console.log(json.scrapedData);
  let tempArray = dataArray;
  tempArray[dataArray.indexOf(item)] = json.scrapedData;
  console.log(tempArray);
  setDataArray(tempArray);
  setLoading(false);
}

async function divideLangChain(
  text,
  dataArray,
  setDataArray,
  setLoading,
  size
) {
  setLoading(true);
  const data = await fetch(
    "https://ai-chat-bot-docker.onrender.com/splittext",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text,
        size,
      }),
    }
  );
  const json = await data.json();
  console.log(json.splitted);
  let newData = [...dataArray];
  for (let i = 0; i < json.splitted.length; i++) {
    newData.push(json.splitted[i].pageContent);
  }
  var index = newData.indexOf(text);
  if (index !== -1) {
    newData.splice(index, 1);
  }
  setDataArray(newData);
  setLoading(false);
  // return json;
}
